import { Component } from '@angular/core';

@Component({
  selector: 'app-blood-donation',
  standalone: true,
  imports: [],
  templateUrl: './blood-donation.component.html',
  styleUrl: './blood-donation.component.scss'
})
export class BloodDonationComponent {

}
